/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { Node } from '@msdyn365-commerce-modules/utilities';
import React, { ReactNode } from 'react';

import { ITileListViewProps } from './dyn-tile-list';

/**
 * View component.
 * @param props - The view properties.
 * @returns Returns props.
 */
export const tileListView: React.FC<ITileListViewProps> = props => {
    const { title, tiles, tileListContainer, tileListHeading, tileItemContainer, singleSlideCarouselComponentProps } = props;
    return (
        <Node {...tileListContainer}>
            <Node {...tileListHeading}>{title}</Node>
            <Node {...singleSlideCarouselComponentProps}>
                {tiles.map((tileItem: ReactNode, index: number) => {
                    const keyIndex = `tile-list-item__${index}`;
                    return (
                        <Node {...tileItemContainer} key={keyIndex}>
                            {tileItem}
                        </Node>
                    );
                })}
            </Node>
        </Node>
    );
};

export default tileListView;
